const FULL_WIDTH_SELECTOR = '[data-clientside-hook~="fullWidthElement"]'

export default () => {
  const scrollbarWidth =
    window.innerWidth - document.documentElement.clientWidth

  if (scrollbarWidth === 0) {
    return null
  }

  return [...document.querySelectorAll(FULL_WIDTH_SELECTOR)].map(element => {
    const fullWidthCSSprop = `100vw - ${scrollbarWidth}px`

    /* eslint-disable-next-line no-param-reassign */
    element.style.width = `calc(${fullWidthCSSprop})`

    /* eslint-disable-next-line no-param-reassign */
    element.style.left = `calc((${fullWidthCSSprop} - 100%) / 2 * -1)`

    return element
  })
}
